<script>
    export default {
        name: "ModalVuetifyRoot",
        data() {
            return {
                isModalVuetifyRoot: true,
            };
        },
    }
</script>